/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBrackets = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m6 5.4 1.7-1.7-1.4-1.4L4 4.6v5L1.6 12 4 14.4v5l2.3 2.3 1.4-1.4L6 18.6v-5L4.4 12 6 10.4zm14 4.2v-5l-2.3-2.3-1.4 1.4L18 5.4v5l1.6 1.6-1.6 1.6v5l-1.7 1.7 1.4 1.4 2.3-2.3v-5l2.4-2.4z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgBrackets as Brackets };
